import { useSelector } from "react-redux"

// --------------------------------------------------
// 🎉 contents are fetched in /auto/autoWordPress.js
// --------------------------------------------------

export const useWordPressContents = ()=>{
    return useSelector(({wordpress})=> wordpress || {})
}

export const useWordPressContent = (id)=>{
    return useWordPressContents()[id]
}